import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ForceChangePassword() {
  const { user, refresh, impersonating } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);
  if (!user?.must_change_password || impersonating) return null;

  const save = async (e) => {
    e.preventDefault();
    if (next.length < 8) { toast.error("La nueva contraseña debe tener al menos 8 caracteres."); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Contraseña actualizada.");
      setCurrent(""); setNext("");
      await refresh();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" data-testid="force-change-password">
      <form onSubmit={save} className="bg-white rounded-2xl p-6 w-full max-w-md space-y-4">
        <div className="flex items-center gap-2"><KeyRound className="w-5 h-5 text-accent" /><h2 className="text-lg font-semibold">Crea tu nueva contraseña</h2></div>
        <p className="text-sm text-muted-foreground">Entraste con una clave provisoria. Por seguridad, elige ahora tu propia contraseña.</p>
        <div>
          <Label>Clave provisoria</Label>
          <Input type="password" className="h-12 rounded-xl mt-1.5" value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="fcp-current" />
        </div>
        <div>
          <Label>Nueva contraseña (mínimo 8 caracteres)</Label>
          <Input type="password" className="h-12 rounded-xl mt-1.5" value={next} onChange={(e) => setNext(e.target.value)} data-testid="fcp-new" />
        </div>
        <Button type="submit" disabled={busy} className="w-full h-12 rounded-xl" data-testid="fcp-submit">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Guardar contraseña"}
        </Button>
      </form>
    </div>
  );
}
